import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { SeminarDateSeriesDetailsModel } from '../../../models/seminar.model';
import { TrainingCategoryModel } from '../../../models/training-category.model';
import { AlertService } from '../../../services/alert.service';
import { SeminarService } from '../../../services/seminar.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-seminar',
  templateUrl: './seminar.component.html',
  styleUrl: './seminar.component.scss',
  standalone: false,
})
export class SeminarComponent implements OnInit {
  public isLoading = true;
  public seminarDateSeries: SeminarDateSeriesDetailsModel;
  public seminarCategory: TrainingCategoryModel;
  constructor(
    private location: Location,
    private router: Router,
    public userService: UserService,
    private activatedRoute: ActivatedRoute,
    private seminarService: SeminarService,
    private alertService: AlertService
  ) {}

  public redirectUrl = this.router.url;

  async ngOnInit(): Promise<void> {
    const dateSeriesIdParam =
      this.activatedRoute.snapshot.params['dateSeriesId'];
    if (!dateSeriesIdParam) {
      this.location.back();
    }
    const seminarCategoryId = this.activatedRoute.snapshot.params['categoryId'];
    await this.fetchSeminarById(
      +atob(dateSeriesIdParam),
      seminarCategoryId ? +atob(seminarCategoryId) : null
    );
    this.isLoading = false;
  }

  private async fetchSeminarById(
    seminarDateSeriesId: number,
    seminarCategoryId?: number
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.seminarService
        .getSeminarDateSeriesById(seminarDateSeriesId)
        .subscribe({
          next: seminarDateSeries => {
            this.navigateAwayFromDraftSeminars(seminarDateSeries);
            this.seminarDateSeries = seminarDateSeries;
            if (
              seminarCategoryId &&
              this.seminarDateSeries.category2?.id === seminarCategoryId
            ) {
              this.seminarCategory = this.seminarDateSeries.category2;
            }
            if (!this.seminarCategory) {
              this.seminarCategory = this.seminarDateSeries.category1;
            }
            resolve();
          },
          error: error => {
            console.error('Error fetching seminar', error);
            this.alertService.showErrorAlert(
              'Das Seminar konnte nicht geladen werden.'
            );
            reject();
          },
        });
    });
  }

  private navigateAwayFromDraftSeminars(
    seminarDateSeries: SeminarDateSeriesDetailsModel
  ): void {
    if (seminarDateSeries.seminar.isDraft) {
      this.router.navigate(['/']);
      this.alertService.showInfoAlert(
        'Das Seminar, dass du aufgerufen hast ist leider nicht mehr verfügbar.',
        10000
      );
    }
  }

  public freeSeats(seminarDateSeries: SeminarDateSeriesDetailsModel): number {
    return (
      seminarDateSeries.seminar.maxParticipants -
      seminarDateSeries.participantCount
    );
  }

  public bookCourse() {
    this.router.navigate([
      '../seminars/registration',
      this.seminarCategory ? btoa(this.seminarCategory.id.toString()) : null,
      btoa(this.seminarDateSeries.seminar.id.toString()),
      btoa(this.seminarDateSeries.dateSeriesId.toString()),
    ]);
  }

  public convertWaitlistToBooking() {
    this.router.navigate([
      '../seminars/registration',
      this.seminarCategory ? btoa(this.seminarCategory.id.toString()) : null,
      btoa(this.seminarDateSeries.seminar.id.toString()),
      btoa(this.seminarDateSeries.dateSeriesId.toString()),
      'waitlist',
      btoa(this.seminarDateSeries.waitlistBookingId.toString()),
    ]);
  }

  public onCancel(): void {
    this.location.back();
  }

  public isOnWaitlist(): boolean {
    return this.seminarDateSeries?.currentUserStatus === 'waitlist';
  }

  public isRegistered(): boolean {
    return this.seminarDateSeries?.currentUserStatus === 'registered';
  }

  public isPending(): boolean {
    return this.seminarDateSeries?.currentUserStatus === 'pending';
  }

  public isBookable(): boolean {
    if (
      this.seminarDateSeries.dates.find(item =>
        moment(item.startDate).isBefore(moment())
      )
    ) {
      return false;
    }
    if (this.seminarDateSeries.seminar.isCanceled) {
      return false;
    }
    return true;
  }
}
